
<template>
  <!-- style="border-radius: 30px;" -->
  <div style="border-radius: 30px">
    <div>
      <h1
        class="h1"
        style="
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 25px;
        "
      >
        {{ objData.start }}-{{ objData.end }}
      </h1>
      <div>
        <el-row :gutter="20" style="position: relative">
          <el-col :span="12">
            <div class="headerItem">
              <!-- <div class="">
                <img src="../../../assets/images/cpname.png" alt="产品名称" />
              </div> -->
              <div class="">
                <span class="product-t"> 产品名称：</span>
                <span class="product-t2">{{ obj.productNameCn }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="headerItem">
              <!-- <div class="">
                <img src="../../../assets/images/huowu.png" alt="可接货物" />
              </div> -->
              <div class="">
                <!-- 可接货物：{{ obj.goodsType }} -->
                <span class="product-t"> 可接货物：</span>
                <span class="product-t2">{{ obj.goodsType }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="headerItem">
              <!-- <div class="">
                <img src="../../../assets/images/baoshui.png" alt="是否包税" />
              </div> -->
              <div class="">
                <!-- 分泡方式： {{ obj.countWeightMethod }} -->
                <span class="product-t"> 分泡方式：</span>
                <span class="product-t2">{{ obj.countWeightMethod }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="headerItem">
              <!-- <div class="">
                <img
                  style="width: 100%"
                  src="../../../assets/images/tiji.png"
                  alt="体积重比率"
                />
              </div> -->
              <div>
                <span class="product-t">体积重比率:</span>
                <span class="product-t2"> {{ obj.volumeFactor }}</span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content" style="max-width: 220px">
                    <span
                      >体积重比率用于计算体积重，体积重=长*宽*高/体积重比率</span
                    ><br />
                    <span
                      >例如:100CM*100CM*100CM规格的箱子，若体积重比率=6000，则体积重=100*100*100/6000
                      ≈ 167KG</span
                    >
                  </div>
                  <span
                    style="font-size: 14px; color: #f9a123"
                    class="el-icon-question"
                  ></span>
                </el-tooltip>
              </div>
            </div>
          </el-col>

          <el-col
            :span="12"
            v-show="
              countData.weightVolumeRatioDesc && countData.chargeType == 'CBM'
            "
          >
            <div class="headerItem">
              <div class="">
                <img src="../../../assets/images/jipao.png" alt="重量转换" />
              </div>
              <div class="" style="margin-left: 18px">
                重量转换：{{ countData.weightVolumeRatioDesc }}
              </div>
            </div>
          </el-col>
          <div class="test" v-if="typeValue == 1">
            <div class="zxBtn" @click="onlineConsultation" style="float: right">
              在线咨询
            </div>
            <div
              class="gotBtn"
              style="float: right; margin-left: 10px"
              @click="handleOrder"
            >
              立即下单
            </div>
          </div>
        </el-row>
        <div class="table">
          <el-table :data="tableData" style="width: 100%" size="mini" :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column prop="name" label="分区名字" align="center">
            </el-table-column>
            <el-table-column
              :label="item.tab1"
              align="center"
              v-for="(item, index) of list"
              :key="index"
            >
              <el-table-column
                align="center"
                :prop="item_1.s1"
                :label="item_1.name1"
                v-for="(item_1, key_1, index_1) of item.children"
                :key="index_1"
              >
              </el-table-column>
              <el-table-column
                align="center"
                :prop="item_1.s2"
                :label="item_1.name2"
                v-for="(item_1, key_1, index_1) of item.children"
                :key="index_1"
              >
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 50px 0">
          <el-tabs v-model="activeName" @tab-click="TabClick">
            <el-tab-pane label="下单须知" name="first">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="obj.orderInstruction"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="特殊要求" name="second">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="obj.specialRequirements"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="温馨提示" name="third">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="obj.orderTips"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="包装要求" name="fourth">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="obj.packagingRequirements"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="赔付标准" name="standards">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="obj.paymentStandard"
              ></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SmallGetItemBill",
  props: {
    typeValue: {
      type: Number,
    },
    objData: {
      type: Object,
    },
    val: {
      type: Number,
    },
    type: {
      type: Boolean,
      default: false,
    },
    showStatus: Boolean,
    countData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // tableData: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    theadData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    BillItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    payType: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      obj: {}, // 所有数据
      list: [], // 表格头数据
      tableData: [], // 表格数据
      activeName: "first",
    };
  },
  watch: {
    showStatus(newVal) {
      if (!newVal) this.activeName = "first";
    },
    type(newVal, oldVal) {
      if (newVal) {
        this.activeName = "first";
      }
    },
  },
  computed: {},
  methods: {
    // 页面数据初始化
    getInit() {
      // console.log("999", this.objData)
      let data = {
        desCountryCode: this.objData.desCountryCode,
        productId: this.objData.productId.toString(),
      };
      // console.log("init", data)
      this.axios
        .post("/ies/jiuyu/getQuoteDetail", data)
        .then((res) => {
          // console.log("dialog---", res);
          // this.FBAtoCk = res.data.datas;
          // this.editableTabs[0].list = res.data.datas;
          if (res.data.code == 200) {
            this.obj = res.data.data;
            this.tableData = res.data.data.tableData;
            this.list = res.data.data.tabList;
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {});
    },
    TabClick() {},
    getUsertypeRap() {
      console.log(this.BillItem);
      this.$parent.$parent.getUsertypeRap(this.BillItem);
    },
    // 在线咨询
    onlineConsultation() {
      window.open(
        "https://p.qiao.baidu.com/cps/chat?siteId=17320739&userId=34266456&siteToken=5e01b35862b5ca97b9b51380e3ae2b80",
        "_blank"
      );
    },
    // 去下单
    handleOrder() {
      // console.log("order---", this.objData, this.objData.productId, this.objData.businessType)
      // return
      // 判断用户是否登录
      if (!this.sessionGetUserInfo().token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return;
      }

      // return;

      this.axios
        .get("/api/user/cititrans/login")
        .then((res) => {
          if (res.data.code == 200) {
            let token = res.data.data.token;
            let linkUrl = res.data.data.linkUrl;
            let type = this.objData.businessType;
            // 物流产品业务类型IBC、DBC 跳
            // http://ioms.cititrans.com/order-create/orders-forward?token=xxx&productkindId=xxx
            // 物流产品业务类型ICB、DCB 跳
            // http://ioms.cititrans.com/order-create/orders-reverse?token=xxx&productkindId=xxx
            // 物流产品业务类型ICC、DCC 跳
            // http://ioms.cititrans.com/order-create/orders-personal?token=xxx&productkindId=xxx
            let url = "";
            if (type == "IBC" || type == "DBC") {
              url = `${linkUrl}/order-create/orders-forward?token=${token}&productkindId=${this.objData.productId}`;
            } else if (type == "ICB" || type == "DCB") {
              url = `${linkUrl}/order-create/orders-reverse?token=${token}&productkindId=${this.objData.productId}`;
            } else if (type == "ICC" || type == "DCC") {
              url = `${linkUrl}/order-create/orders-personal?token=${token}&productkindId=${this.objData.productId}`;
            } else {
            }
            console.log("url---", url);
            window.open(url);
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {});
    },
  },
  created() {},
  mounted() {
    this.getInit();
    console.log("objData---", this.objData);
  },
};
</script>
<style scoped>
.headerItem {
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
  color: #333333;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
}
.headerItem img {
  float: left;
  width: 14px;
  height: 14px;
}
.test {
  position: absolute;
  right: 12px;
  bottom: 20px;
}

.Xqicon {
  background: url("../../../assets/zx.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 14px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 4px;
}

.Qxdicon {
  background: url("../../../assets/qxd.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 14px;
  text-align: center;
  color: #ffffff !important;
  font-weight: bold;
  float: left;
  margin-right: 2px;
}

.gotBtn {
  cursor: pointer;
  margin-top: 24px;
  width: 130px;
  height: 50px;
  background: #FF4D01;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #ffffff;
  margin-right: 20px;
}

.zxBtn {
  cursor: pointer;
  margin-top: 24px;
  width: 130px;
  height: 46px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #FF4D01;
  border: #FF4D01 2px solid;
}

.product-t {
  color: #999;
  font-size: 14px;
}
.product-t2 {
  color: #333;
  font-size: 14px;
}
.headerItem >>> .el-tooltip {
  color: #FF4D01 !important;
  cursor: pointer;
}
.el-table--border th, .el-table__fixed-right-patch {
  background: #f5f5f5 !important;
}

/deep/ .el-tabs__item {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/SmallGetItemBill.vue